import { useAuth } from "@/context/AuthContext";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export default function Settings() {
  const { user } = useAuth();
  const baseUrl = process.env.REACT_APP_BACKEND_URL;

  return (
    <div data-testid="settings-page" className="max-w-2xl">
      <h1 className="text-2xl font-bold mb-6">Settings</h1>
      <div className="space-y-6">
        <Card>
          <CardHeader><CardTitle className="text-base">Account</CardTitle></CardHeader>
          <CardContent className="text-sm space-y-2">
            <div className="flex justify-between"><span className="text-gray-500">Email</span><span>{user?.email}</span></div>
            <div className="flex justify-between"><span className="text-gray-500">Role</span><span>{user?.role}</span></div>
          </CardContent>
        </Card>
        <Card>
          <CardHeader><CardTitle className="text-base">Public Card URL Format</CardTitle></CardHeader>
          <CardContent className="text-sm space-y-2">
            <p className="text-gray-500">Every card's permanent public URL follows this pattern:</p>
            <div className="font-mono bg-gray-50 p-2 rounded border break-all">{baseUrl}/api/c/RVX-00001</div>
            <p className="text-gray-400 text-xs">
              This URL is encoded in the QR code and NFC tag. It never changes, even when the card is reassigned.
              The server performs a database lookup and redirects to the currently assigned Google Review URL.
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
